import React, { useState } from "react";

import { Container, ButtonFilter, TextClearFilters, ConfirmButton, SelectContent } from "./styles";

//icons
import { IoMdArrowDropdown } from "react-icons/io";
import { BsEraser } from "react-icons/bs";

//Utils
import Select from "react-select";

//Mui components
import Menu from "@mui/material/Menu";
import DateFilter from "../DateFilter/DateFilter";
import { filtersHelper } from "@helpers/filters";
import { arrayHelper } from "@helpers/array";
import { Filter } from "@domain/models/Filters";
import { Client } from "@domain/models/Client";
import { useRefinementList } from "react-instantsearch";
import { SelectOption } from "@domain/models/SelectOption";
import { customSelectStyle } from "@constants/customSelectStyle";
import { Route } from "@domain/models/Route";
import useUser from "@hooks/useUser";

type Props = {
  filters: Filter[];
  filterTypes: { headerName: string; field: string }[];
  dateField: keyof Client | keyof Route;
  defaultTitle: string;
  onChangeFilters: (filters: Filter[]) => void;
  onClearFilters: () => void;
};

const HeaderFilter = ({
  filters,
  filterTypes,
  dateField,
  defaultTitle,
  onChangeFilters,
  onClearFilters,
}: Props) => {
  const { operatorsNames } = useUser();
  const [selectedField, setSelectedField] = useState("");

  const { items } = useRefinementList({
    attribute: selectedField ? selectedField : "name",
    operator: "or",
    sortBy: ["name:asc"],
    limit: 100,
  });

  const filteredItems =
    selectedField === "operatorName" && operatorsNames.length > 0
      ? items.filter((x) => operatorsNames.includes(x.label))
      : items;

  const [filterCalendar, setFilterCalendar] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const clearAllFilters = () => {
    onClearFilters();
  };

  const handleMenuClose = () => {
    setSelectedField("");
    setAnchorEl(null);
  };

  const handleMenuOpen = (event, headerName) => {
    if (headerName === "Data") {
      setFilterCalendar(true);
    } else {
      setFilterCalendar(false);
    }

    setSelectedField(event.currentTarget.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChangeFilters = async (newValueArray, field) => {
    const exists = filters.findIndex((x) => x.field === field);

    if (exists != -1) {
      if (newValueArray.length > 0) {
        const newObject: Filter = {
          ...filters[exists],
          values: newValueArray,
        };

        const newArray = arrayHelper.replaceItemOfArray(filters, exists, newObject);

        onChangeFilters(newArray);
      } else {
        const newArray = arrayHelper.removeItemOfArray(filters, exists);

        onChangeFilters(newArray);
      }
    } else {
      const newObject: Filter = {
        field: field,
        type: "string",
        values: newValueArray,
      };

      onChangeFilters([...filters, newObject]);
    }
  };

  const handleChangeDateFilter = (calendarValues, field) => {
    const exists = filters.findIndex((x) => x.field === field);

    if (exists != -1) {
      if (calendarValues?.selectedStart || calendarValues?.selectedEnd) {
        const newObject = {
          ...filters[exists],
          dateValue: calendarValues,
        };

        const newArray = arrayHelper.replaceItemOfArray(filters, exists, newObject);

        onChangeFilters(newArray);
      } else {
        const newArray = arrayHelper.removeItemOfArray(filters, exists);

        onChangeFilters(newArray);
      }
    } else {
      const newObject: Filter = {
        field: field,
        type: "date",
        values: [],
        dateValue: calendarValues,
      };

      onChangeFilters([...filters, newObject]);
    }
  };

  const buttonHandle = (label, field) => {
    const exists = filters.find((x) => x.field === field);
    if (exists) {
      if (exists.type === "string") {
        if (exists.values?.length > 1) {
          return `${exists.values[0].value} +${exists.values.length - 1}`;
        } else {
          return `${exists.values[0].value}`;
        }
      }

      if (exists.type === "date") {
        const selectedStart = exists?.dateValue?.selectedStart;
        const selectedEnd = exists?.dateValue?.selectedEnd;

        if (selectedStart && selectedEnd?.day) {
          return `${selectedStart.day}/${selectedStart.month}/${selectedStart.year} - 
                        ${selectedEnd.day}/${selectedEnd.month}/${selectedEnd.year}`;
        }

        if (selectedStart) {
          return `${selectedStart.day}/${selectedStart.month}/${selectedStart.year}`;
        }
      }
    } else {
      if (field.toLowerCase().includes("date") && defaultTitle) {
        return defaultTitle;
      }
      return `${label}`;
    }
  };

  const getOptions = (selectedField: string) => {
    const filter = filters.find((filters) => filters.field === selectedField);

    if (filter) {
      const options = filteredItems.filter((item) =>
        filter?.values.find((x) => x.value !== item.value)
      );
      return options;
    }

    return filteredItems;
  };

  return (
    <Container>
      {filterTypes.map((item, index) => (
        <ButtonFilter
          key={index}
          id={item.field}
          onClick={(event) => handleMenuOpen(event, item.headerName)}
        >
          <h4>{buttonHandle(item.headerName, item.field)}</h4>
          <IoMdArrowDropdown
            style={{ cursor: "pointer" }}
            size={18}
            color="#808B9F"
            fill="#808B9F"
          />
        </ButtonFilter>
      ))}

      <TextClearFilters onClick={() => clearAllFilters()}>
        <BsEraser style={{ cursor: "pointer", marginRight: -5 }} />
        Limpar
      </TextClearFilters>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        style={{ zIndex: 100000 }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          style: {
            width: 400,
            height: 400,
            padding: 10,
            borderRadius: 15,
          },
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {filterCalendar ? (
          <DateFilter
            filters={filters}
            dateField={dateField}
            onFilterDate={(values) => handleChangeDateFilter(values, dateField)}
            clearDateFilter={() => handleChangeDateFilter(null, dateField)}
            onClose={handleMenuClose}
          />
        ) : (
          <SelectContent>
            <Select
              isClearable={false}
              isSearchable={true}
              defaultValue={
                selectedField && filters && filtersHelper.getDefaultValues(selectedField, filters)
              }
              onChange={(item: SelectOption[]) => handleChangeFilters(item, selectedField)}
              closeMenuOnSelect={false}
              options={getOptions(selectedField)}
              isMulti={true}
              styles={customSelectStyle}
              autoFocus={true}
              menuIsOpen
              defaultMenuIsOpen
            />
            <ConfirmButton onClick={() => handleMenuClose()}>
              <h3>OK</h3>
            </ConfirmButton>
          </SelectContent>
        )}
      </Menu>
    </Container>
  );
};

export default HeaderFilter;
